import { allowedActionsSync } from "@gtmhub/permissions/utils";
import { IPlanningSession } from "@gtmhub/sessions";
import { IUser } from "@gtmhub/users";
import dayjs from "@gtmhub/dayjs";

export const getMessagesCount = (messagesCount: number): string => {
  return messagesCount > 99 ? "99+" : messagesCount.toString();
};

export interface IElementBaseTopPos {
  [element: string]: number;
}

export function filterInActiveSessions(sessions: IPlanningSession[], currentUserId: IUser, hideReadonlySessions: boolean): IPlanningSession[] {
  const todayDate: string = dayjs().format("YYYY-MM-DD");

  return sessions.filter((eachSession) => {
    const oneMonthBeforeStartDate: string = dayjs(eachSession.start).subtract(1, "months").format("YYYY-MM-DD");
    const oneMonthAfterEndDate: string = dayjs(eachSession.end).add(1, "months").format("YYYY-MM-DD");

    return (
      oneMonthBeforeStartDate <= todayDate && oneMonthAfterEndDate >= todayDate && !shouldHideSessionFromNavigation(eachSession, currentUserId, hideReadonlySessions)
    );
  });
}

export function shouldHideSessionFromNavigation(session: IPlanningSession, currentUser: IUser, featureToggle: boolean): boolean {
  if (!featureToggle) {
    return false;
  }

  const allowed = allowedActionsSync(currentUser, session.access);
  return !allowed.includes("update");
}
